<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>Recuperação de Senha</h1>
                <p class="text-muted">Entre com sua nova senha</p>
                
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="password" ref="password" type="password" class="form-control" required placeholder="Senha"   />
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input v-model="password2" ref="password2" type="password" class="form-control" required placeholder="Confirmar senha"   />
                </b-input-group>

                <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errormessage && this.errormessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errormessage }}</div>
                </b-input-group>

                <!--
                <b-button variant="success" block>Criar Conta</b-button>
                -->
              </b-form>
            </b-card-body>
            <b-card-footer class="p-4">
              <b-row>
                <b-col cols="6">                  
                  <b-button block class="btn btn-facebook" @click="backToPortal"><span>Voltar ao Portal</span></b-button>
                </b-col>
                <b-col cols="6">
                  <b-button block class="btn btn-twitter" type="button" @click="changePassword" :disabled="waitingResponse"><span>Alterar Senha</span></b-button>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: 'PasswordRecovery',

  data: function() {
    return {
      waitingResponse: false,

      passwordPolicy: /^.{8,}$/,
      passwordPolicyMessage: 'No mínimo 8 caracteres',

      errormessage: '',
      uid: null,
      auxKey: null,
      password: '',
      password2: ''
    }
  },

  methods: {
  
    async saveNewPassword() {
      var s = this;

      s.waitingResponse =  true

      var postData = {
            "companyId": s.$store.state.config.companyId,
            "uid":  this.$route.query.uid,
            "auxKey":  this.$route.query.key,
            "password": this.password
          }   

      console.log(postData)

      await axios.post(
          this.$store.state.ws_url + "/user/passwordrecovery/change",
          postData 
          
      ).then(function(resp) {
        s.errormessage = resp.data.message
        s.password = ""
        s.password2 = ""
        s.waitingResponse =  false
      }).catch(function (error) {
        //console.log(error)
        s.errormessage = error.response.data.message;
        s.waitingResponse =  false
      });

    },
   
    changePassword() {
      this.errormessage = ''

      if(!this.$route.query.uid || !this.$route.query.key || this.$route.query.uid == '' || this.$route.query.key == '') {
        this.errormessage = "Tentativa de alteração de senha não aceita ou já expirada. Solicite a recuperçãp de senha novamente."
      }
      else
      if(this.password != '' && !this.passwordPolicy.test(this.password)) {      
        this.errormessage = this.passwordPolicyMessage
      }
      
      if(this.errormessage == '') {
        if(this.password != '' && this.password2 != '') {
          if(this.password == this.password2) {
            this.saveNewPassword();
          }
          else {
            this.errormessage = "Senha e confirmar senha diferentes. Verifique e tente novamente.";
          }
        }
        else {
          this.errormessage = 'Preencha todos os campos e tente novamente.';
        }
      }
    },
    backToPortal() {
      this.$router.push({ path: '/dashboard' })
    },
    backLogin() {
      this.$router.push({ path: '/pages/login' })
    },

    async getPreferences() {
      
      var s = this

      await axios.get(
        this.$store.state.ws_url + "/sys/preference/password/policy?companyId=" + this.$store.state.config.companyId
      ).then(function(resp) {
        s.passwordPolicy = new RegExp(resp.data.obj.stringValue)
        s.passwordPolicyMessage = resp.data.obj.description


      }).catch(function(error) {
        s.passwordPolicy = /^.{8,}$/
      })
    }

  },

  mounted: function() {
      this.getPreferences()
  }

}
</script>
